import styled from '@emotion/styled';

export const SpecialTitle = styled.p`
	font-size: ${(props) => props.theme.fontSize.size4xl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	background: none;
	color: #212529;
	@media screen and (max-width: 900px) {
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
`;
export const SponsorGroupList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5.6rem;
	width: 100%;
	@media screen and (max-width: 900px) {
		gap: 4.8rem;
	}
	@media screen and (max-width: 600px) {
		gap: 4rem;
	}
`;
export const SponsorGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	@media screen and (max-width: 600px) {
		gap: 1.8rem;
	}
`;
export const SponsorGradeTitle = styled.h3`
	position: relative;
	display: flex;
	align-items: center;
	gap: 1.2rem;
	padding-left: 1.6rem;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	color: #212529;
	&.platinum {
		font-size: ${(props) => props.theme.fontSize.size3xl};
	}
	&.gold {
		font-size: ${(props) => props.theme.fontSize.size2xl};
	}
	&.silver {
		font-size: ${(props) => props.theme.fontSize.sizeXl};
	}
	&.bronze {
		font-size: ${(props) => props.theme.fontSize.sizeLg};
	}
	&::before {
		content: '';
		display: block;
		width: 1.2rem;
		height: 1.2rem;
		border-radius: 50%;
		background-color: #adb5bd;
		box-shadow: 0 0 0 0.6rem rgba(173, 181, 189, 0.14);
	}
	&::after {
		content: '';
		flex: 1;
		height: 1px;
		background-color: #e9ecef;
	}
	&.platinum::before {
		background-color: #748ffc;
		box-shadow: 0 0 0 0.6rem rgba(116, 143, 252, 0.14);
	}
	&.gold::before {
		background-color: #f59f00;
		box-shadow: 0 0 0 0.6rem rgba(245, 159, 0, 0.14);
	}
	&.silver::before {
		background-color: #868e96;
		box-shadow: 0 0 0 0.6rem rgba(134, 142, 150, 0.14);
	}
	&.bronze::before {
		background-color: #d9480f;
		box-shadow: 0 0 0 0.6rem rgba(217, 72, 15, 0.14);
	}
	@media screen and (max-width: 900px) {
		padding-left: 0;
		font-size: ${(props) => props.theme.fontSize.sizeLg};
		gap: 1rem;
		&.platinum {
			font-size: ${(props) => props.theme.fontSize.size2xl};
		}
		&.gold {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
		}
		&.silver {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
		}
		&.bronze {
			font-size: ${(props) => props.theme.fontSize.sizeMd};
		}
		&::before {
			width: 1rem;
			height: 1rem;
			box-shadow: 0 0 0 0.5rem rgba(173, 181, 189, 0.14);
		}
		&.platinum::before {
			box-shadow: 0 0 0 0.5rem rgba(116, 143, 252, 0.14);
		}
		&.gold::before {
			box-shadow: 0 0 0 0.5rem rgba(245, 159, 0, 0.14);
		}
		&.silver::before {
			box-shadow: 0 0 0 0.5rem rgba(134, 142, 150, 0.14);
		}
		&.bronze::before {
			box-shadow: 0 0 0 0.5rem rgba(217, 72, 15, 0.14);
		}
	}
	@media screen and (max-width: 420px) {
		font-size: ${(props) => props.theme.fontSize.sizeMd};
		&.platinum {
			font-size: ${(props) => props.theme.fontSize.sizeXl};
		}
		&.gold {
			font-size: ${(props) => props.theme.fontSize.sizeLg};
		}
		&.silver {
			font-size: ${(props) => props.theme.fontSize.sizeMd};
		}
		&.bronze {
			font-size: ${(props) => props.theme.fontSize.sizeSm};
		}
	}
`;
export const LogoGrid = styled.div`
	width: 100%;
	display: grid;
	justify-content: start;
	&.platinum {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		max-width: 112rem;
	}
	&.gold {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		max-width: 112rem;
	}
	&.silver,
	&.bronze {
		grid-template-columns: repeat(4, minmax(0, 1fr));
	}
	@media screen and (max-width: 1200px) {
		&.platinum,
		&.gold {
			max-width: none;
		}
		&.gold,
		&.silver,
		&.bronze {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}
	}
	@media screen and (max-width: 900px) {
		grid-template-columns: repeat(2, 1fr);
		&.platinum,
		&.gold,
		&.silver,
		&.bronze {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}
	@media screen and (max-width: 420px) {
		grid-template-columns: repeat(1, 1fr);
		&.platinum,
		&.gold,
		&.silver,
		&.bronze {
			grid-template-columns: repeat(1, minmax(0, 1fr));
		}
	}
`;
export const LogoImgWrapper = styled.a`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 9.6rem;
	padding: 2.4rem 3.2rem;
	box-sizing: border-box;
	&:focus-visible {
		outline: 2px solid #495057;
		outline-offset: 0.4rem;
	}
	&.platinum {
		height: 18rem;
		padding: 1.6rem 2.4rem;
	}
	&.amorepacific {
		padding: 0.7rem 1.1rem;
	}
	&.gold {
		height: 10rem;
		padding: 2.8rem 3.8rem;
	}
	&.j2kbio {
		padding: 1.8rem 2.6rem;
	}
	&.silver {
		height: 8.8rem;
		padding: 2.8rem 3.8rem;
	}
	&.silver-large {
		padding: 2rem 2.8rem;
	}
	&.silver-second {
		padding: 2.2rem 3.1rem;
	}
	&.bronze {
		height: 7.6rem;
		padding: 2.8rem 3.8rem;
	}
	&.bronze-large {
		padding: 2.5rem 3.5rem;
	}
	&.bronze-selected {
		padding: 1.75rem 2.75rem;
	}
	&.bronze-fourth {
		padding: 0.85rem 1.85rem;
	}
	&.bronze-eighth {
		padding: 2.25rem 3.25rem;
	}
	&.bronze-third {
		padding: 2.7rem 3.7rem;
	}
	@media screen and (min-width: 901px) and (max-width: 1200px) {
		&.platinum {
			height: 16rem;
			padding: 1.8rem 2.6rem;
		}
		&.amorepacific {
			padding: 0.9rem 1.3rem;
		}
		&.gold {
			height: 9.4rem;
			padding: 2.6rem 3.6rem;
		}
		&.j2kbio {
			padding: 1.7rem 2.4rem;
		}
		&.silver {
			height: 8.4rem;
			padding: 2.6rem 3.6rem;
		}
		&.silver-large {
			padding: 1.9rem 2.8rem;
		}
		&.silver-second {
			padding: 2.1rem 3rem;
		}
		&.bronze {
			height: 7.4rem;
			padding: 2.6rem 3.6rem;
		}
		&.bronze-large {
			padding: 2.4rem 3.3rem;
		}
		&.bronze-selected {
			padding: 1.65rem 2.55rem;
		}
		&.bronze-fourth {
			padding: 0.9rem 1.8rem;
		}
		&.bronze-eighth {
			padding: 2.15rem 3.05rem;
		}
		&.bronze-third {
			padding: 2.5rem 3.5rem;
		}
	}
	@media screen and (max-width: 600px) {
		height: 7.2rem;
		padding: 1.8rem 2.4rem;
		&.platinum {
			height: 13rem;
			padding: 1.2rem 1.8rem;
		}
		&.amorepacific {
			padding: 0.6rem 0.9rem;
		}
		&.gold {
			height: 7.6rem;
			padding: 2rem 2.8rem;
		}
		&.j2kbio {
			padding: 1.3rem 1.8rem;
		}
		&.silver {
			height: 7rem;
			padding: 2rem 2.8rem;
		}
		&.silver-large {
			padding: 1.4rem 2rem;
		}
		&.silver-second {
			padding: 1.6rem 2.2rem;
		}
		&.bronze {
			height: 6.4rem;
			padding: 2rem 2.8rem;
		}
		&.bronze-large {
			padding: 1.8rem 2.5rem;
		}
		&.bronze-selected {
			padding: 1.2rem 1.8rem;
		}
		&.bronze-fourth {
			padding: 0.6rem 1.1rem;
		}
		&.bronze-eighth {
			padding: 1.6rem 2.2rem;
		}
		&.bronze-third {
			padding: 1.9rem 2.7rem;
		}
	}
	@media screen and (min-width: 601px) and (max-width: 900px) {
		height: 8.8rem;
		padding: 2.4rem 4rem;
		&.platinum {
			height: 15.2rem;
			padding: 1.4rem 2.4rem;
		}
		&.amorepacific {
			padding: 0.7rem 1.2rem;
		}
		&.gold {
			height: 8.8rem;
			padding: 2.6rem 4rem;
		}
		&.j2kbio {
			padding: 1.7rem 2.6rem;
		}
		&.silver {
			height: 8rem;
			padding: 2.6rem 4rem;
		}
		&.silver-large {
			padding: 1.8rem 3rem;
		}
		&.silver-second {
			padding: 2.1rem 3.3rem;
		}
		&.bronze {
			height: 7.2rem;
			padding: 2.6rem 4rem;
		}
		&.bronze-large {
			padding: 2.4rem 3.6rem;
		}
		&.bronze-selected {
			padding: 1.65rem 2.85rem;
		}
		&.bronze-fourth {
			padding: 0.9rem 2.05rem;
		}
		&.bronze-eighth {
			padding: 2.15rem 3.35rem;
		}
		&.bronze-third {
			padding: 2.5rem 3.9rem;
		}
	}
`;
export const LogoImg = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`;
